"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const rfid_tag_dumptruck_types_1 = require("./rfid-tag-dumptruck.types");
const rfid_tag_1 = require("services/configuration/rfid-tag");
const dump_truck_1 = require("services/master-data/dump-truck");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, rfid_tag_1._getRfidTagDumpTruck)(dataStates);
    if (response.isError) {
        dispatch({
            type: rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.SET_DATA_GRID, payload });
    }
});
const closeError = () => dispatch => {
    dispatch({
        type: rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onDataStateChange = (dataStates) => dispatch => {
    const payload = {
        dataStates
    };
    dispatch({ type: rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.ON_PAGE_CHANGE, payload });
};
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.ON_SORT_CHANGE, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const { mutationMode } = payload;
    const response = yield (0, dump_truck_1._editDumpTruck)({
        id: payload.dataItem.id,
        contractor_id: (_a = payload.dataItem) === null || _a === void 0 ? void 0 : _a.contractor_id,
        dumptruck_no: (_b = payload.dataItem) === null || _b === void 0 ? void 0 : _b.dumptruck_no,
        capacity_volume: (_c = payload.dataItem) === null || _c === void 0 ? void 0 : _c.capacity_volume,
        dumptruck_spec: payload.dataItem.dumptruck_spec,
        is_active: (_d = payload.dataItem) === null || _d === void 0 ? void 0 : _d.is_active,
        rfid_tag: payload.dataItem.rfid_tag,
        modified_date: new Date(),
        modified_by: payload.dataItem.modified_by
    });
    const dataItem = Object.assign(Object.assign({}, payload.dataItem), { id: response.data.id });
    const isSuccess = !response.isError;
    if (isSuccess)
        dispatch({
            type: rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.ON_SAVE_DATAITEM,
            payload: Object.assign(Object.assign({}, payload), { dataItem, mutationMode, isSuccess })
        });
    else
        dispatch({
            type: rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
        });
});
exports.default = {
    getDataGrid,
    onDataStateChange,
    onClickMutation,
    onFilterChange,
    onSortChange,
    closeError,
    onSaveDataItem
};
